import { createSelector } from 'reselect';
import get from 'lodash/get';

import { createSelectFieldOptions } from '../../../utils/common';
import { initialState } from './reducer';

const selectRegisterDomain = state => state.Register || initialState;

const selectRegistrations = () =>
  createSelector(selectRegisterDomain, subState => get(subState, 'registrationsList.data'));
const selectRegistrationToken = () => createSelector(selectRegisterDomain, subState => get(subState, 'regToken'));
const selectRegistrationErrorMessage = () =>
  createSelector(selectRegisterDomain, subState => get(subState, 'regError'));
const selectRegistrationProfile = () => createSelector(selectRegisterDomain, subState => get(subState, 'regProfile'));

const selectActiveRegistration = () =>
  createSelector(selectRegisterDomain, subState => get(subState, 'activeRegistration'));
const selectAgenciesListOptions = (withAllData = false) =>
  createSelector(selectRegisterDomain, subState => {
    const agencies = get(subState, 'searchAgencies.data', []);
    return createSelectFieldOptions(agencies, 'id', 'name', {}, withAllData);
  });

export {
  selectRegistrations,
  selectActiveRegistration,
  selectAgenciesListOptions,
  selectRegistrationErrorMessage,
  selectRegistrationProfile,
  selectRegistrationToken,
};
